import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';

import {
  BASE_URL,
  SETTING_IMAGE,
  EDIT_IMAGE,
  EDIT_THEME,
  UPLOAD_IMAGE,
  THEME_SELECTION,
  UPDATE_THEME,
  GET_WHITE_LABEL,
  CORE_URL,
  M_POST
} from '@/utils/api';

@Module({ name: 'whitelabel' })
export default class WhiteLabel extends VuexModule {
  list: any = [];

  @Mutation
  mutateSettingImage(whitelabel: any) {
    this.list = whitelabel;
  }

  @Action({ commit: 'mutateSettingImage', rawError: true })
  async FetchSettingImage(params: Record<string, any> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + SETTING_IMAGE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch setting image failed');

      const _data = data?.data ?? {};
      const game = _data?.image?.game;

      if (game && typeof game === 'object') {
        delete (game as any).loadingBackgroundColor;
        delete (game as any).svgLoading;
        delete (game as any).licence;
        delete (game as any).landscapeLicence;
      }

      if (_data?.image && typeof _data.image === 'object') {
        delete (_data.image as any).landingPage;
      }

      return _data;
    } catch (err: any) {
      throw toError(err, 'Fetch setting image failed');
    }
  }

  @Action({ rawError: true })
  async EditSettingTheme(params: Record<string, any> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + EDIT_THEME,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Edit theme failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Edit theme failed');
    }
  }

  @Action({ rawError: true })
  async UploadImage(params: any) {
    try {
      const { data } = await axios({
        url: BASE_URL + UPLOAD_IMAGE,
        data: params,
        method: M_POST,
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      assertOk(data, 'Upload image failed');
      return data?.data ?? data;
    } catch (err: any) {
      throw toError(err, 'Upload image failed');
    }
  }

  @Action({ rawError: true })
  async ImageUpdate(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + EDIT_IMAGE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update image failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Update image failed');
    }
  }

  @Action({ rawError: true })
  async LandingPageSetting(params: Record<string, any> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + SETTING_IMAGE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch landing page setting failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch landing page setting failed');
    }
  }

  @Action({ rawError: true })
  async ThemeSelectionSetting(params: Record<string, any> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + THEME_SELECTION,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch theme selection failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch theme selection failed');
    }
  }

  @Action({ rawError: true })
  async UpdateThemeSelectionSetting(params: Record<string, any> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + UPDATE_THEME,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update theme selection failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Update theme selection failed');
    }
  }

  @Action({ rawError: true })
  async FetchWhiteLabel(params: Record<string, any> = {}) {
    try {
      const { data } = await axios({
        url: CORE_URL + GET_WHITE_LABEL,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch white label failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch white label failed');
    }
  }
}
